'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router';
import Formsy from 'formsy-react';
import ListItem from 'components/base/list-components/ListItem';
import LoadingHeader from 'components/base/LoadingHeader';
import Spinner from 'components/base/Spinner';
import 'styles/List.scss';
import appConstants from 'constants/appConstants';


const propTypes = {
    loading: PropTypes.bool,
    condensed: PropTypes.bool,
    link: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    noFormsy: PropTypes.bool,
};

class List extends React.Component {

    constructor(props) {
        super(props);
        this._handleSelectAllClick = this._handleSelectAllClick.bind(this);
        this.state = {
            isSelectAll: false,
        };
    }

    _handleSelectAllClick() {
        this.setState({
            isSelectAll: !this.state.isSelectAll,
        });
    }

    render() {
        var footerContent = null;
        if (this.props.onLoadMoreCallback && !this.props.loading) {
            footerContent = <div key={9999999} className="end-list-options-container"><a className="link" href="javascript:void(0)" onClick={this.props.onLoadMoreCallback} query={this.props.query}>View more</a></div>;
        } else if (this.props.onLoadMoreCallback && this.props.loading) {
            footerContent = (
                <div>
                    <div
                        key={9999999}
                        className="end-list-options-container viewMoreSpinner "
                    >
                        <Spinner
                            display={this.props.loading}
                            id={'spinner' + 9999999}
                            color={'#255bc7'}
                        />
                    </div>
                </div>
            );
        }

        var headerContent = this.props.heading ? (
            <h5 className={this.props.hasColoredBackground ? "header no-line" : "header"}>
                <LoadingHeader
                    icon={this.props.icon}
                    loading={this.props.loading}
                    hasColoredBackground={this.props.hasColoredBackground}
                >
                    {this.props.heading}
                </LoadingHeader>
            </h5>
        ) : null;
        var linkContent = "";

        var children = this.props.children;


        if (this.props.error) {

            var errorContent = <div className="error">{appConstants.error.PAGE_SECTION.ERROR.format(this.props.error.toLowerCase())}</div>;
            children = <ListItem content={errorContent} />;

        } else if (this.props.actions) {

            linkContent = <div className="list-action-container">{this.props.actions}</div>;

        } else if (this.props.link && headerContent) {

            headerContent = (
                <Link
                    className="link"
                    to={this.props.link}
                    query={this.props.query ? this.props.query : {}}
                    title={this.props.title}
                >
                    <h5 className={this.props.hasColoredBackground ? "header no-line" : "header"}>
                        <LoadingHeader
                            icon={this.props.icon}
                            loading={this.props.loading}
                            hasColoredBackground={this.props.hasColoredBackground}
                        >
                            {this.props.heading}
                        </LoadingHeader>
                    </h5>
                </Link>
            );

            linkContent = <div className="link page-link icon-next" to={this.props.link}></div>;
        }

        let content;

        if (this.props.noFormsy) {
            content = children;
        } else {
            content = (
                <Formsy>
                    {children}
                </Formsy>
            );
        }

        const classes = classNames(
            'list', this.props.className, {
                'end-list-options-container-spacer': footerContent,
                'condensed': this.props.condensed,
            }
        );       

        return (
            <div id={this.props.id} className={classes}>
                {headerContent}
                {linkContent}
                <div className="list-container">
                    {content}
                </div>
                {this.props.nextPageLink && footerContent}
            </div>
        );
    }
}


List.propTypes = propTypes;

export default List; 
